import React from "react";

function SelectionBox() {
  return <div>SelectionBox</div>;
}

export default SelectionBox;
